<template lang="pug">
  .color-kit-pdp
    //- pdp hero layout
    .container
      .row.xs-f-small.max-at-tweak
        .fixed-width-tweak-upper
          ColorKitHero

    //- highlights CTA
    .container
      .row.xs-f-small.max-at-tweak
        .fixed-width-tweak-upper
          ColorKitHighlightsCTA.xs-12

    //- info bullets
    .container
      .row.xs-f-small.max-at-tweak
        .fixed-width-tweak-upper
          .product-bullets.xs-12
            .bullets.xs-12
              ul.xs-f-small.lg-f-medium.max-at-tweak
                li.xs-f-small.lg-f-medium.max-at-tweak(v-for="bullet in product.prodInfo" v-html="bullet")

    //- all color link
    .container
      .row.xs-f-small.max-at-tweak
        .fixed-width-tweak-upper.b-line
          .complete-range.text-center
            .range
              p.xs-f-small.lg-f-medium.max-at-tweak View our&nbsp;
                a.underline(href="/shop/permanent-hair-color") complete range of permanent&nbsp;colors

    //- ingredients
    .container
      .row.xs-f-small.md-f-medium.max-at-tweak
        .fixed-width-tweak-upper.b-line
          ProductIngredients(v-if="product.id" v-bind:product="product")

    //- color kit Box
    .container
      .row.xs-f-small.md-f-medium.max-at-tweak
        .fixed-width-tweak-upper
          ColorKitUnboxed

    //- Contact color crew
    .container
      .row.xs-f-small.md-f-medium.lg-f-small.max-at-tweak
        .fixed-width-tweak-upper
          ExpertiseIncluded.row.xs-pt-100m

    //- Satisfaction
    SatisfactionGuarantee
    
    //- Reviews
    .container.review-wrap(v-if="product.id")
      .row.xs-f-small.md-f-medium.lg-f-small.max-at-tweak
        .fixed-width-tweak-upper
          .title-wrap.text-center
            SectionTitle(text="Reviews")
            p.desc-short.color-slate.xs-f-medium.lg-f-xmedium.max-at-tweak {{ product.short_description }}
            template(v-if="product.reviewInfo")
              stars(:rating="product.reviewInfo.average").inline-block
              span.color-black {{product.reviewInfo.count}}

          Reviews(:productId="product.id" :productUrlKey="product.url_key")

    //- Xsell
    .container(v-if="product.code")
      .row.text-center
        SectionTitle.xs-pb-25m Recommended
        span.color-slate.xs-f-medium.lg-f-xmedium.max-at-tweak with {{ product.name }}
        PdpXsellCarousel(:productCode="product.code")
  
</template>

<script>
  import { mapState, mapActions } from 'vuex';
  import ColorKitHero from './ColorKitHero/ColorKitHero';
  import ProductIngredients from './../ProductIngredients';
  import ColorKitUnboxed from './ColorKitUnboxed';
  import ColorKitHighlightsCTA from './ColorKitHighlightsCTA';
  import ExpertiseIncluded from "../../ExpertiseIncluded";
  import Reviews from "../Reviews";
  import SectionTitle from "../../SectionTitle";
  import SatisfactionGuarantee from "../SatisfactionGuarantee";
  import PdpXsellCarousel from "../PdpXsellCarousel/PdpXsellCarousel";

  import vueAdvisorSvc from "../../../services/vueAdvisorSvc";

  export default {
    name: "ColorKitPdp",

    components: {
      PdpXsellCarousel,
      ColorKitHero,
      ProductIngredients,
      ColorKitUnboxed,
      ColorKitHighlightsCTA,
      ExpertiseIncluded,
      Reviews,
      SectionTitle,
      SatisfactionGuarantee
    },

    computed: {
      ...mapState('pdp', ['product'])
    },

    methods: {
      ...mapActions('pdp', ['openPlaygroundModal'])
    },

    mounted() {
      // open try it on modal via urlParam
      if (this.$route.query.try) {
        this.openPlaygroundModal();
      }

      if (this.$route.query.cr) {
        var crUnwatch = this.$watch('product', () => {
          vueAdvisorSvc.persistCustomerAnswers({
            quizName: 'colorist-recommended',
            answers: {
              colorist_match: this.product.code,
              last_match_type: 'colorist'
            }
          }).then(() => {
            this.$root.advisorUpdated += 1;
            crUnwatch();
          });
        });
      }
    }
  }
</script>

<style scoped lang="stylus">
  .color-kit-pdp
    .product-bullets      
      .bullets
        border-top 1px solid color-fog
        padding 1.5em 0
        margin-top 1.5em
      
      ul
        padding-left 5%
        list-style disc
        
        li
          position relative
          display inline-block
          vertical-align top
          padding-left 1em
          margin-right 0.5em
          margin-bottom 0.25em
          
          &:before
            content '\2022'
            position absolute
            top 0
            left 0
                  
    .complete-range
      border-top 1px solid color-fog
      
      .range
        padding 1.5em 5%

    .expertise-included
      padding-top 3em
      border-top 1px solid #cbc8c7
      
    .review-wrap
      .reviews
        border-bottom 1px solid #cbc8c7
        padding-bottom 2em
        margin-bottom 3em

      .title-wrap
        padding 1.5em 0

        .section-title
          padding-bottom 0.6em

        .desc-short
          padding-bottom 0.5em

    .b-line
      > *
        border-bottom 1px solid color-fog
      
    @media mq-tablet
      .product-bullets
        padding-left 10%
        padding-right 10%

    @media mq-tablet-plus
      .fixed-width-tweak-upper
        padding-left 3%
        padding-right 3%

    @media mq-desktop-md
      .product-bullets
        ul
          li
            width 23em
            
    @media mq-desktop-plus
      .product-bullets
        padding 1.5em 0
        
        ul
          li
            width 25em
  
</style>
